import React from 'react'
import "./Consultation.css"

export default function Consultation() {
return (
  <>
      <div className="Consultation">
      </div>
      <div className="ConsultationHeading1">
          Consult with wellness experts
      </div>
      <div className='ConsultationContent1'>
        Set up health consultations with experienced doctors and therapists on our app. Simply select a service, answer a few questions, and we'll connect you to someone who is the right-fit for you. 
      </div>
      <button className="ConsultationButton1">
        <span className='ConsultationButton1Text'> 
          Get a consultation
        </span>
      </button>
      
      <img className="ConsultationImages1" src = "./content/usman-yousaf-MP9W9DtdoBI-unsplash 2.svg" alt="a doctor"></img>
      
  </>
)
}
